import React from "react";
import { Card, Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { apiOrganization } from "../../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { SearchSelectApi } from "../../../../../../../../../../../../services/Api/types";
import useCollapseCard from "../../hooks/useCollapseCard";
import TipSettingsTextsCard from "./TipSettingsTextsCard";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
	search: string;
}

const TipSettingsCard = ({ form, search }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		watch,
		setValue,
	} = form;

	const getSearchedResults = () => {
		const searchToLowerCase = search.toLowerCase();
		if (!search) return false;

		return (
			t("modules.venue_settings.field.tips_settings.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.online_payment_menu_discount.title").toLowerCase().includes(searchToLowerCase)
		);
	};
	const { toggleCollapse, collapseIn, getCollapseIconStyles } = useCollapseCard(
		search,
		undefined,
		getSearchedResults()
	);

	const searchDiscount = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getDiscountsSearchSelect(
			search,
			{
				...params,
				"discount_type|e": "TIP",
				"tip_item_id|a": "",
				"editable|true": "",
			},
			{
				cancelToken: options?.token,
			}
		);
	};

	const handleOnPaymentDiscountChange = (value: SearchSelectApi | undefined) => {
		setValue("tip_settings.online_payment_menu_discount.name", value ? value.label : "");
	};

	return (
		<Card className="venue-settings">
			<Card.Body>
				<div className="title" onClick={() => toggleCollapse()}>
					<h5>{t("modules.venue_settings.field.tips_settings.title")}</h5>
					<CollapseSVG className="collapse-icon" style={getCollapseIconStyles()} />
				</div>
				<Collapse in={collapseIn}>
					<div>
						<fieldset className="form-group">
							<FormSelectGroup
								errors={errors}
								control={control}
								name="tip_settings.online_payment_menu_discount_id"
								loadOptions={searchDiscount}
								getOptionValue={(option) => option.id}
								defaultValue={{
									id: watch("tip_settings.online_payment_menu_discount_id"),
									label: watch("tip_settings.online_payment_menu_discount")?.name,
								}}
								label={t("modules.venue_settings.online_payment_menu_discount.title")}
								data-testid="tip_settings.online_payment_menu_discount_id"
								onChange={(_, obj) => handleOnPaymentDiscountChange(obj)}
							/>
						</fieldset>
						<TipSettingsTextsCard form={form} />
					</div>
				</Collapse>
			</Card.Body>
		</Card>
	);
};

export default TipSettingsCard;
